import Select from 'react-select'
import { Button } from '../../../../components/ui/button'
import { useTransactionFilterController } from './useTransactionFilterController'
import { BasicFilter } from '../../../../components/BasicFilter'
import { FilterSelectStyle } from '../../../../components/BasicFilter/FilterSelectStyle'
import { cn } from '../../../../../app/utils/cn'
import { optionsStatusSelect } from '../../../../../app/utils/status'
import { BasicAsyncSelect } from '@/view/components/BasicAsyncSelect'
import { DateRangePicker } from '@/view/components/DateRangePicker'
import { AlignBottom, Coin1 } from 'iconsax-react'

interface TransactionFilterChartProps {
  variant?: 'default' | 'onlyButton'
  setMetric?: (metric: 'count' | 'total') => void
  metric?: 'count' | 'total'
}

const metricsWithLabels = [
  { value: 'count' as const, label: <AlignBottom /> },
  { value: 'total' as const, label: <Coin1 /> },
] as const

export const TransactionFilterChart = ({
  variant = 'default',
  setMetric,
  metric: metricProp,
}: TransactionFilterChartProps) => {
  const {
    errors,
    handleClearFilter,
    handleFilterSubmit,
    handleSelectCustomer,
    handleSelectSeller,
    handleSelectStatus,
    handleSelectTeam,
    selectedSellerOptions,
    selectedCustomerOptions,
    selectedStatusOptions,
    selectedTeamOptions,
    isSubmitting,
    isFetching,
    isLoading,
    handleLoadMore,
    handleLoadMoreCustomer,
    isFetchingCustomer,
    isLoadingCustomer,
    handleLoadMoreTeam,
    isFetchingTeam,
    isLoadingTeam,
    isSeller,
    setParamsCustomer,
    customerData,
    sellerData,
    setParamsSeller,
    setParamsTeam,
    teamsData,
    selectedDate,
    handleDateChange,
    selectedProductOptions,
    productOptions,
    handleSelectProduct,
    selected,
    changeMetric,
  } = useTransactionFilterController({
    metric: metricProp,
    setMetric,
  })

  const { DropdownIndicator, customStyles } = FilterSelectStyle({
    isMulti: true,
  })

  return (
    <div className="flex items-center justify-between">
      {variant === 'default' && (
        <h1 className="text-xl font-medium">Transações</h1>
      )}
      <div className="flex gap-2">
        <BasicFilter>
          <form onSubmit={handleFilterSubmit}>
            <div className="px-4">
              <h2 className="mb-2 font-medium text-black04">Data</h2>
              <DateRangePicker
                date={selectedDate}
                onDateChange={handleDateChange}
                numberOfMonths={1}
              />
            </div>
            <div className="space-y-4 p-4">
              <div className="space-y-2">
                <h3 className="font-medium text-black04">Produto</h3>
                <Select
                  options={productOptions}
                  isMulti
                  onChange={handleSelectProduct}
                  value={selectedProductOptions}
                  placeholder="Selecione o(s) produto(s)"
                  styles={customStyles}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator,
                  }}
                />
              </div>
              <div className="space-y-2">
                <h3 className="font-medium text-black04">Cliente</h3>
                <BasicAsyncSelect
                  data={customerData}
                  handleSelectedValue={handleSelectCustomer}
                  isLoading={isFetchingCustomer || isLoadingCustomer}
                  onMenuScrollToBottom={handleLoadMoreCustomer}
                  placeholder="Selecione o(s) cliente(s)"
                  setParams={setParamsCustomer}
                  value={selectedCustomerOptions}
                  inputError={errors.customerIds?.message}
                />
              </div>
              {!isSeller && (
                <>
                  <div className="space-y-2">
                    <h3 className="font-medium text-black04">Equipes</h3>
                    <BasicAsyncSelect
                      data={teamsData}
                      handleSelectedValue={handleSelectTeam}
                      isLoading={isFetchingTeam || isLoadingTeam}
                      onMenuScrollToBottom={handleLoadMoreTeam}
                      placeholder="Selecione a(s) equipe(s)"
                      setParams={setParamsTeam}
                      value={selectedTeamOptions}
                      inputError={errors.teamIds?.message}
                    />
                  </div>

                  <div className={cn('space-y-2')}>
                    <h3 className="font-medium text-black04">Vendedor</h3>
                    <BasicAsyncSelect
                      data={sellerData}
                      handleSelectedValue={handleSelectSeller}
                      isLoading={isFetching || isLoading}
                      onMenuScrollToBottom={handleLoadMore}
                      placeholder="Selecione o(s) vendedor(es)"
                      setParams={setParamsSeller}
                      value={selectedSellerOptions}
                      inputError={errors.sellerIds?.message}
                    />
                  </div>
                </>
              )}

              <div className="space-y-2">
                <h3 className="font-medium text-black04">Status</h3>
                <Select
                  options={optionsStatusSelect}
                  isMulti
                  onChange={handleSelectStatus}
                  value={selectedStatusOptions}
                  placeholder="Selecione o(s) status"
                  styles={customStyles}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator,
                  }}
                />
                {errors.status?.message}
              </div>
            </div>
            <div className="my-5 w-full border-b-[1px] border-gray01" />
            <div className="flex items-center justify-between p-4">
              <Button
                onClick={handleClearFilter}
                variant="outline"
                className="w-24 rounded-full bg-gray02 text-xs font-bold"
              >
                Limpar
              </Button>
              <Button
                type="submit"
                disabled={isSubmitting}
                className="w-20 rounded-full bg-primary text-xs font-bold text-white01"
              >
                Filtrar
              </Button>
            </div>
          </form>
        </BasicFilter>
        <Button
          onClick={() => changeMetric()}
          variant="outline"
          size="sm"
          className="rounded-lg py-[18px]"
        >
          {metricsWithLabels[selected].label}
        </Button>
      </div>
    </div>
  )
}
